export const QuickPosSessionCreationFieldConfig = {
  posBox: {
    label: 'global.pos_box.label',
    rules: ['required'],
    fieldPath: 'posBox',
    errorFieldPath: 'posBox',
    fieldReadPath: 'pos_box',
    name: 'posBox',
    showlabel: true,
  },
  beginning_cash: {
    fieldPath: 'beginning_cash',
    fieldReadPath: 'beginning_cash',
    name: 'beginning_cash',
    label: 'global.beginning_cash.label',
    options: [],
    id: 'global__beginning_cash',
    rules: ['required', 'numeric'],
    appendIcon: 'euro-sign',
    fieldAttributes: {
      autocomplete: 'off',
      type: 'number',
      step: '0.01',
    },
    warningRules: [],
    veeValidation: false,
  },
  observations: {
    fieldPath: 'observations',
    fieldReadPath: 'observations',
    name: 'observations',
    label: 'global.observations.label',
    options: [],
    id: 'global__observations',
    rules: ['nullable'],
  },
};
